import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { ISearchLocationModel } from '../../../entire/services/navigation.service';

@Component({
  standalone: false,
  selector: 'faq-form',
  templateUrl: './faq-form.component.html'
})
export class FaqFormComponent extends CustomComponent {
  @Output() onFormChange = new EventEmitter<void>();
  @Output() onLocationFound = new EventEmitter<ISearchLocationModel>();

  public faqCount = 20;
  public faqs = [];

  constructor(private _translate: TranslateService) {
    super();

    this._init();
  }

  private _init() {
    for (let i = 1; i <= this.faqCount; i++) {
      const question = this._translate.instant(`faqForm.faq_${i}.question`);
      const answer = this._translate.instant(`faqForm.faq_${i}.answer`);

      if (question && answer) {
        this.faqs.push({ question, answer });
      }
    }
  }
}
